module.exports = __webpack_public_path__ + "img/picture_27.2adfe614.png";